import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useFormChangeHandler } from 'hooks/useFormChangeHandler';
import { useSubmitHandler } from 'hooks/useSubmitHandler';
import { useCreateData } from 'hooks/useApiHooks';
import CustomSelect from 'components/form/custom-select';

const ChangeSession = ({ initialData, onSuccess, onError }) => {
    const API_URL = '/booking-change-sesi';

    const [formData, setFormData] = useState({
        booking_id: initialData?.id,
        sesi_id: initialData?.sesi.id,
    });

    const { createData, loading: creatingData } = useCreateData(API_URL);

    const handleChange = useFormChangeHandler(setFormData);

    const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
        createData,
        onSuccess,
        onError
    );

    useEffect(() => {
        if (initialData) {
            setFormData({
                booking_id: initialData?.id,
                sesi_id: initialData?.sesi.id,
                booking_date: initialData?.booking_date,
            });
        }
    }, [initialData]);

    const formatSessionOptionLabel = ({ label, originalData }) => (
        <div className="d-flex flex-column">
            <span>{label}</span>
            <span className="text-muted">{originalData?.start_time} - {originalData?.end_time}</span>
            <span className="text-muted">avability - {originalData?.available}</span>
        </div>
    );

    // Handle form submission
    const handleBeforeSubmit = (e) => {
        console.log('formData', formData);
        e.preventDefault();
        // Manipulate formData before submitting
        const manipulatedData = {
            booking_id: formData?.booking_id,
            sesi_id: formData?.sesi_id.value
        };

        handleSubmit(manipulatedData, e);
    };

    return (
        <div className="container-fluid mt-4">
            {/* Form Cek Ketersediaan */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className='mb-3'>
                        <span className='text-muted d-block mb-2'>Booking ID: {initialData?.id}</span>
                        <span className='text-muted d-block mb-2'>Tanggal Pemesanan: {initialData?.booking_date}</span>
                        <span className='text-muted d-block mb-2'>Sesi: {initialData?.sesi.name}</span>
                        <span className='text-muted d-block mb-2'>Waktu: {initialData?.sesi.start_time} - {initialData?.sesi.end_time}</span>
                        <span className='text-muted d-block mb-2'>Customer: {initialData?.customer.name}</span>
                    </div>
                    <form onSubmit={(e) => handleBeforeSubmit(e)}>
                        <div className="form-group mb-3">
                            <label htmlFor="sesi_id" className="form-label">Pilih Sesi</label>
                            <CustomSelect
                                url="/sesi"
                                value={formData?.sesi_id}
                                onChange={(selectedOption) => setFormData({ ...formData, sesi_id: selectedOption })}
                                formatOptionLabel={formatSessionOptionLabel}
                                valueKey="id"   // Sesuaikan dengan format data
                                labelKey="name" // Sesuaikan dengan format data
                                placeholder="Pilih Sesi"
                                isDisabled={isSubmitting}
                            />
                        </div>
                        <div className="form-group d-grid">
                            <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                                Ganti Sesi
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangeSession;
